export default "__VITE_ASSET__BTwdgy2w__"